import {NgModule} from '@angular/core';
import {HttpProfileService} from '@infrastructure/http/profile/http-profile.service';
import {PROFILE} from '@infrastructure/http/profile/profile';
import {loginRouting} from '@presentation/pages/login/login.routing';
import {SharedModule} from '@shared/shared.module';
import {LoginComponent} from './login.component';

@NgModule({
  imports: [loginRouting, SharedModule],
  providers: [{provide: PROFILE, useClass: HttpProfileService}],
  declarations: [LoginComponent]
})
export class LoginModule {}
